import styled, { css } from 'styled-components';
import { device, colors } from '../../styles/stylesheets';

export const Container = styled.div`
  border-radius: 4px;
  @media ${device.fromTablet} {
    padding: 0 24px;
    background-color: ${colors.alabaster2};
  }
`;

export const ContentSpinner = styled.div`
  width: 100%;
  height: 100%;
`;

export const MessageQuantTasks = styled.blockquote`
  margin: 20px 0 20px 0;
  width: 100%;
  ${({ onClick }) => onClick && (
    css`cursor: pointer;`
  )}
  ::after {
    content: '';
    height: 10px;
    width: 10px;
    margin-left: 12px;
    border-bottom: 0.4px solid ${colors.primary};
    border-right: 0.4px solid ${colors.primary};

    transform: rotate(-45deg);
    transform: ${({ expanded }) => (expanded ? 'rotate(-135deg)' : 'rotate(45deg)')};
    display: ${({ show }) => (show ? 'inline-block' : 'none')};
  }
`;

export const IconStatusTask = styled.div`
  display: inline-block;
  margin-right: 10px;
  width: 12px;
  height: 12px;
  border-radius: 12px;
  ${({ status }) => (status ? css`
    background: ${colors.primary};
    box-shadow: 0px 0px 10px rgba(255, 102, 0, 0.8);
  ` : css`
    background: ${colors.greyMedium};
    box-shadow: none;
  `)}
`;
